var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.content
    ? _c(
        "div",
        {
          staticClass:
            "bg-white text-black pb-8 pt-24 lg:pb-15 grid grid-cols-12 px-ogs gap-x-gs",
        },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            !_vm.loading
              ? _c("div", { staticClass: "col-span-12" }, [
                  (_vm.colour && _vm.colour.text) || _vm.content.text
                    ? _c(
                        "h3",
                        {
                          staticClass:
                            "text-3xl md:text-4xl mb-20 md:mb-15 text-center max-w-xl md:max-w-3xl mx-auto leading-tight",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                (_vm.colour && _vm.colour.text) ||
                                  _vm.content.text
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "col-span-12 mb-20 md:mb-15" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center space-y-3 max-w-xl md:max-w-3xl mx-auto",
                    },
                    [
                      _c("div", {
                        staticClass: "h-10 bg-grey w-2/3 animate-pulse rounded",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "h-10 bg-grey w-3/4 animate-pulse rounded",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "h-10 bg-grey w-3/5 animate-pulse rounded",
                      }),
                    ]
                  ),
                ]),
          ]),
          _vm._v(" "),
          _vm.colour && _vm.colour.imagesSecondary.length > 0 && !_vm.loading
            ? _c(
                "div",
                { staticClass: "md:hidden col-span-12 -mx-ogs" },
                [
                  _c(
                    "swiper",
                    {
                      ref: "swiper",
                      staticClass: "swiper",
                      attrs: { options: _vm.swiperOptions },
                    },
                    [
                      _vm._l(
                        _vm.colour.imagesSecondary,
                        function (image, index) {
                          return _c(
                            "swiper-slide",
                            {
                              key: image.id,
                              staticClass: "rounded-lg overflow-hidden mb-10",
                              class: _vm.marginClass(index),
                            },
                            [
                              _c("picture", [
                                _c("source", {
                                  attrs: {
                                    type: "image/webp",
                                    srcSet: image.webpSm,
                                  },
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: image.defaultSm,
                                    alt: image.title,
                                    loading: "lazy",
                                    width: "750",
                                    height: "1320",
                                  },
                                }),
                              ]),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "swiper-pagination",
                        attrs: { slot: "pagination" },
                        slot: "pagination",
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.colour && _vm.colour.imagesSecondary.length > 0 && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "hidden md:flex gap-x-gs col-span-12 xl:col-span-10 xl:col-start-2",
                },
                _vm._l(
                  _vm.colour.imagesSecondary.slice(0, 3),
                  function (image) {
                    return _c(
                      "div",
                      {
                        key: image.id,
                        staticClass: "rounded-lg overflow-hidden flex-1",
                      },
                      [
                        _c("picture", { staticClass: "block" }, [
                          _c("source", {
                            attrs: {
                              type: "image/webp",
                              srcset: `${image.webpLg}`,
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "w-full",
                            attrs: {
                              srcset: `${image.defaultLg}`,
                              src: image.defaultLg,
                              alt: image.title,
                              loading: "lazy",
                              width: "950",
                              height: "1240",
                            },
                          }),
                        ]),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }